import { useEffect, useState } from 'react'

import { useConnectedAccount } from '../connectedAccount'
import { useUserContext } from '../user/useUserContext'
import { DEFAULT_MODULE_TYPE, type ModuleThemeColours, getModuleThemeColours } from './constants'
import { ModuleThemeContext } from './useModuleTheme'

export const ModuleThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { connectedAccounts } = useConnectedAccount()
  const { activeConnectedAccountId } = useUserContext()
  const activeConnectedAccountType = connectedAccounts.find((ca) => ca.id === activeConnectedAccountId)?.type
  const [moduleTheme, setModuleTheme] = useState<ModuleThemeColours>(
    getModuleThemeColours(activeConnectedAccountType ?? DEFAULT_MODULE_TYPE),
  )

  useEffect(() => {
    setModuleTheme(getModuleThemeColours(activeConnectedAccountType ?? DEFAULT_MODULE_TYPE))
  }, [activeConnectedAccountType, activeConnectedAccountId])

  // Set --dropdown-accent on document root so portaled content (e.g. dropdowns) inherits it
  // Updates the colour of the dropdown hover
  useEffect(() => {
    document.documentElement.style.setProperty('--dropdown-accent', moduleTheme.dropdownAccentVar)
    return () => {
      document.documentElement.style.removeProperty('--dropdown-accent')
    }
  }, [moduleTheme.dropdownAccentVar])

  // Set --loading-accent-1/2 so Loading component and its CSS glow use the active module colours
  useEffect(() => {
    document.documentElement.style.setProperty('--loading-accent-1', moduleTheme.spinner.colour1)
    document.documentElement.style.setProperty('--loading-accent-2', moduleTheme.spinner.colour2)
    return () => {
      document.documentElement.style.removeProperty('--loading-accent-1')
      document.documentElement.style.removeProperty('--loading-accent-2')
    }
  }, [moduleTheme.spinner.colour1, moduleTheme.spinner.colour2])

  return <ModuleThemeContext.Provider value={{ moduleTheme, setModuleTheme }}>{children}</ModuleThemeContext.Provider>
}
